import React from 'react';
import { useSetResolved } from 'src/core/engine/router';
import { BlogRouter } from 'src/components/Blog/BlogRouter';

import { Container, Wrapper } from '../../components/Layout';

import '../../scss/_root-component.scss';

export const BlogRoot: React.FC = () => {
    useSetResolved();

    return (
        <Wrapper variant="widget-wrapper">
            <Container>
                <BlogRouter />
            </Container>
        </Wrapper>
    );
};

export default BlogRoot;
